import { Link } from "react-router-dom";
import { styled } from "@glitz/react";
import { black, darkGrey, spacing } from "../theme";

type CategoryCrumbs = { main: string; sub?: string; variant?: "category" };
type BrandCrumbs = { variant: "brand"; title: string };

export const BreadCrumbs = (props: CategoryCrumbs | BrandCrumbs) => {
  if (props.variant === "brand") {
    return (
      <Wrapper aria-label="breadcrumb">
        <span>varumärke</span>
        {" / "}
        <SubCategory>{props.title}</SubCategory>
      </Wrapper>
    );
  }

  const { main, sub } = props;
  return (
    <Wrapper aria-label="breadcrumb">
      <span>
        {sub ? (
          <Link style={LinkDecoration} to={`/kategorier/${main}`}>
            <StyledLink>{main.toLowerCase()}</StyledLink>
          </Link>
        ) : (
          main.toLowerCase()
        )}
      </span>
      {sub && (
        <>
          {" / "}
          <SubCategory>{sub.toLowerCase()}</SubCategory>
        </>
      )}
    </Wrapper>
  );
};

const Wrapper = styled.nav({
  marginTop: spacing.s,
  marginBottom: spacing.s,
});

const SubCategory = styled.span({
  color: black,
});

const LinkDecoration = {
  color: darkGrey,
  textDecoration: "none",
};
const StyledLink = styled.span({
  color: darkGrey,
  textDecoration: "none",
  ":hover": {
    color: black,
    textDecoration: "underline",
  },
});
